/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import {
  getCountry,
  getupdatehealthcondition,
  updatehealthcondition,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import Select from "react-select";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class edithealthcondition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "1",
      radioVariant: "1",
      healthconditionname: "",
      healthconditionnameError: null,
      countrydetails: [],
      country: [],
      countryError: null,
      show_in_app: "2",
      _notificationSystem: null,
      cardHidden: true,
      errormessages: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handlesubmit = this.handlesubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.onChange = this.onChange.bind(this);
  }
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Health Condition</b> - Updated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    var hc_id = JSON.parse(localStorage.getItem("healthcondition_id"));
    // console.log(token);
    const obj = token.token;
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );

    getCountry(obj).then((res) => {
      let pcItems = [];
      res.data.map((x, i) => {
        pcItems.push({ value: x.id, label: x.country_name });
      });
      this.setState({
        countrydetails: pcItems,
      });
    });

    // console.log(obj);
    getupdatehealthcondition(hc_id, obj).then((response) => {
      var data = response.data;
      let pc = [];
      let newdata = [];
      pc = data.countries;
      // console.log(hc,'hc ')
      if (pc == null) {
        this.setState({ country: null });
      } else {
        // const splic = pc.split(",");
        // console.log('splic',pc)
        pc.map((fd) => {
          // console.log(fd.id,fd.package_name);
          this.state.countrydetails.map((r) => {
            if (r.value == fd.country_id) {
              // console.log(r)
              newdata.push({ value: r.value, label: r.label });
            }
          });
        });
        var show_in_app_data = "";
        if (data.show_in_app == "0") {
          show_in_app_data = "2";
        } else if (data.show_in_app == "1") {
          show_in_app_data = "1";
        }

        this.setState({
          healthconditionname: data.healthconditionname,
          country: newdata,
          show_in_app: show_in_app_data,
        });
      }
    });
  }
  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network Error</b>. */}
          <b>{getApiErrorMessage(error)}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handlesubmit = (e) => {
    this.setState({ errormessages: [] });
    let error = false;
    // console.log(this.state.medicationcategoryname.length);
    if (this.state.healthconditionname.length == 0) {
      error = true;
      this.setState({
        healthconditionnameError: (
          <small className="text-danger">Health Condition is required.</small>
        ),
      });
    } else {
      this.setState({ healthconditionnameError: null });
    }
    if (this.state.country.length == 0) {
      error = true;
      this.setState({
        countryError: (
          <small className="text-danger">country is required.</small>
        ),
      });
    } else {
      this.setState({ countryError: null });
    }
    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      // console.log(token.token);
      var healthcondition_id = JSON.parse(
        localStorage.getItem("healthcondition_id"),
      );
      const obj = token.token;
      let countryid = [];
      this.state.country.map((c) => {
        countryid.push(c.value);
      });

      var sia = "";
      if (this.state.show_in_app == "1") {
        sia = "1";
      } else if (this.state.show_in_app == "2") {
        sia = "0";
      }

      updatehealthcondition(
        this.state.healthconditionname,
        countryid,
        sia,
        healthcondition_id,
        obj,
      )
        .then((res) => {
          if (res.data.success === false) {
            const message = res.data.data;

            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ errormessages: ermessage });
              this.setState({
                healthconditionnameError: (
                  <small className="text-danger">
                    {message.healthconditionname}
                  </small>
                ),
              });
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
          }

          // this.props.history.push('/admin/medication-category');
        })
        .catch((error) => {
          this.handleNetworkError("bl", error);
          console.log(error, "== error");
        });
    }
  };
  handleChange = (event) => {
    const target = event.target;
    this.setState({
      [target.name]: target.value,
    });
  };
  render() {
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}

                    <FormGroup>
                      <ControlLabel> Health Condition</ControlLabel>
                      <FormControl
                        name="healthconditionname"
                        value={this.state.healthconditionname || ""}
                        onChange={(event) => {
                          this.setState({
                            healthconditionname: event.target.value,
                          });
                          event.target.value === ""
                            ? this.setState({
                                healthconditionnameError: (
                                  <small className="text-danger">
                                    Health Condition is required.
                                  </small>
                                ),
                              })
                            : this.setState({ healthconditionnameError: null });
                        }}
                        placeholder="Enter Health Condition"
                        type="text"
                      />
                      {this.state.healthconditionnameError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Country</ControlLabel>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        placeholder="country"
                        name="country"
                        closeMenuOnSelect={false}
                        isMulti
                        value={this.state.country}
                        onChange={(value) =>
                          this.setState({
                            country: value,
                          })
                        }
                        options={this.state.countrydetails}
                      />

                      {this.state.countryError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Show in App?</ControlLabel>
                      <div className="report_feature">
                        <Radio
                          number="7"
                          option="1"
                          name="show_in_app"
                          onChange={this.onChange}
                          checked={this.state.show_in_app === "1"}
                          label="Yes"
                        />{" "}
                        &nbsp;
                        <Radio
                          number="8"
                          option="2"
                          name="show_in_app"
                          onChange={this.onChange}
                          checked={this.state.show_in_app === "2"}
                          label="No"
                        />
                      </div>
                    </FormGroup>

                    <Button onClick={this.handlesubmit} class="btn-color" fill>
                      Update
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default edithealthcondition;
